document.addEventListener('DOMContentLoaded', () => {

  let elements = document.querySelectorAll('.js-image');

  for (let element of elements) {
    element.addEventListener('click', (event) => {

      let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

      if (isMobile) {
        return;
      }

      event.preventDefault();

      const customEvent = new CustomEvent('slaOpenLightBox', {bubbles: true, detail: {url: event.currentTarget.href}});
      element.dispatchEvent(customEvent);
    })
  }


});
